<template>
  <div class="invite-code-loading">
    <div>
      <img class="logo"
           :src="nowServingLogo">
    </div>
    <div class="mb-m">
      <smd-loading-spinner/>
    </div>
    <p>Checking invite code...</p>
  </div>
</template>

<script>
  import nsLogo from '@/assets/images/now-serving-logo-horizontal.svg';
  import {mapActions, mapMutations} from 'vuex';
  import {getAccessToken} from '@/utils/access-token';
  import {isEmpty} from '@/utils';
  import {
    ACTION_SET_INVITE_CODE_TOKEN,
    INVITE_CODE_TOKEN_QUERY_KEY,
    MUTATE_ROUTE_QUERY,
  } from '@/store/types';
  import {
    HOME_ROUTE,
    LOGIN_ROUTE
  } from '@/router/routes';

  export default {
    name: "InviteCode",
    data() {
      return {
        nowServingLogo: nsLogo,
        tokenQuery: this.$route.query[INVITE_CODE_TOKEN_QUERY_KEY],
      }
    },
    mounted() {
      if (this.tokenQuery) {
        this.setInviteCodeToken(this.tokenQuery);
        this.setRouteQuery({
          ...this.$route.query,
          _context: this.$route.name,
        });
      }

      this.handleRedirect();
    },
    methods: {
      ...mapMutations({
        setRouteQuery: MUTATE_ROUTE_QUERY,
      }),
      ...mapActions({
        setInviteCodeToken: ACTION_SET_INVITE_CODE_TOKEN,
      }),
      handleRedirect() {
        if (isEmpty(getAccessToken())) {
          this.$router.push({
            name: LOGIN_ROUTE,
          })
        } else { // if already logged in
          this.$router.push({
            name: HOME_ROUTE,
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .invite-code-loading {
    display: flex;
    flex-direction: column;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: auto;
    background-color: white;
    z-index: 2;
  }

  .logo {
    @include space-me($prop: margin, $all: l);
    padding: space(m);
    width: 350px;
    height: 120px;
  }
</style>